
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminSteps from '../common/AdminSteps';
import { Row, Col, Table } from 'react-bootstrap';
import * as courseActions from '../../actions/coursesActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import * as groupActions from '../../actions/groupActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as utils from '../../utils/utils';
import * as commonActions from '../../actions/commonActions';
import Spinner from 'react-spinkit';
import label from '../../utils/lngEn';
import ClassForm from './ClassForm';
import AddMeetingModal from './AddMeetingModal';
import { browserHistory } from 'react-router';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import AddDiscountModal from './AddDiscountModal';
import AddLocksModal from './AddLocksModal';
import AddExclusivesModal from './AddExclusivesModal';
import Moment from 'moment';
import AddDropClassPage from './AddDropClassPage';
import _ from 'underscore';

var spanStyle = {
  'font-weight': 'bold',
  'color': '#ccc'
};

var conflictnameless ={
  'cursor': 'auto',
  'text-decoration': 'none'
};

class ClassPageContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      classLoaded: false,
      showMeetingModal: false,
      showConfirmMeetingDelete: false,
      showConfirmCourseDelete: false,
      meetingModalValues: {
        title: '',
        initialValues: {}
      },
      courseDetails: {},
      meetingDeleteId: '',
      showDiscountModal: false,
      showConfirmDicountDelete:false,
      showConfirmExclusiveDelete:false,
      exclusiveDeleteId:'',
      showGroupLocksModal:false,
      discountDeleteId: '',
      discountlist:[],
      discountlistModalValues: {
        title: '',
        courseId: '',
        initialValues: {}
      },
      groupLocks: [],
      groupLocksModalValues: {

      },
      exclusives: [],
      exclusivesModalValues: {

      },
      showExclusivesModal: false,

      progress: 0,
      progressMsg: '',
      progressBar: 0,
      
      // Sorting state for the rankings table
      sortField: 'rank', // Default sort by rank
      sortDirection: 'asc' // 'asc' or 'desc'
    };

    this.handleClassFormSubmit = this.handleClassFormSubmit.bind(this);
    this.openAddMeetingModal = this.openAddMeetingModal.bind(this);
    this.openEditMeetingModal = this.openEditMeetingModal.bind(this);
    this.closeMeetingModal = this.closeMeetingModal.bind(this);
    this.closeDeleteMeetingModal = this.closeDeleteMeetingModal.bind(this);
    this.handleDeleteMeeting = this.handleDeleteMeeting.bind(this);
    this.openDeleteMeetingModal = this.openDeleteMeetingModal.bind(this);
    this.closeDeleteCourseModal = this.closeDeleteCourseModal.bind(this);
    this.openDeleteCourseModal = this.openDeleteCourseModal.bind(this);
    this.handleDeleteCourse = this.handleDeleteCourse.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.openDiscountModal = this.openDiscountModal.bind(this);
    this.openEditDiscountModal = this.openEditDiscountModal.bind(this);
    this.closeDiscountModal = this.closeDiscountModal.bind(this);
    this.setProgress = this.setProgress.bind(this);
    this.openDeleteDiscountModal = this.openDeleteDiscountModal.bind(this);
    this.handleDeleteDiscount = this.handleDeleteDiscount.bind(this);
    this.updateDiscountList = this.updateDiscountList.bind(this);
    this.updateGroupLocks = this.updateGroupLocks.bind(this);
    this.closeGroupLocksModal = this.closeGroupLocksModal.bind(this);
    this.updateExclusives = this.updateExclusives.bind(this);
    this.closeExclusivesModal = this.closeExclusivesModal.bind(this);
    this.openEditExclusiveModal = this.openEditExclusiveModal.bind(this);
    this.handleDeleteExclusive = this.handleDeleteExclusive.bind(this);
    this.closeDeleteExclusiveModal = this.closeDeleteExclusiveModal.bind(this);
    this.closeDeleteDiscountModal = this.closeDeleteDiscountModal.bind(this);
    
    // Bind sort handlers
    this.handleSort = this.handleSort.bind(this);
    this.getSortedRankings = this.getSortedRankings.bind(this);
  }
  
  // Handle sorting when a column header is clicked
  handleSort(field) {
    this.setState(prevState => {
      // If clicking the same field, toggle direction
      if (prevState.sortField === field) {
        return { 
          sortField: field, 
          sortDirection: prevState.sortDirection === 'asc' ? 'desc' : 'asc' 
        };
      }
      // Otherwise, sort by the new field in ascending order
      return { 
        sortField: field, 
        sortDirection: 'asc' 
      };
    });
  }
  
  // Get the sorted rankings based on current sort state
  getSortedRankings(rankings) {
    if (!rankings || rankings.length === 0) return [];
    
    const { sortField, sortDirection } = this.state;
    const rankOrder = { 'Favorite': 0, 'Great': 1, 'Good': 2, 'Acceptable': 3 };
    
    return [...rankings].sort((a, b) => {
      let comparison = 0;
      
      // Sort by the selected field
      if (sortField === 'email') {
        // Sort by email address
        const emailA = (a.student_email || '').toLowerCase();
        const emailB = (b.student_email || '').toLowerCase();
        comparison = emailA.localeCompare(emailB);
      } 
      else if (sortField === 'rank') {
        // Sort by rank (Favorite, Great, Good, Acceptable)
        comparison = rankOrder[a.rank] - rankOrder[b.rank];
      } 
      else if (sortField === 'score') {
        // Sort by score
        comparison = a.score - b.score;
      } 
      else if (sortField === 'student_id') {
        // Sort by student ID
        comparison = a.student_id - b.student_id;
      }
      
      // Apply sort direction
      return sortDirection === 'asc' ? comparison : -comparison;
    });
  }
  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }

    if (this.props.classId) {
      this.setState({ classLoaded: false });
      this.props.courseActions.getCourseById(this.props.classId).then(() => {
        this.setState({ courseDetails: this.props.course, classLoaded: true });
          this.props.courseActions.getDiscountlist(this.props.course.id).then((res) => {
            this.setState({ discountlist: res.results });
          });
          this.props.courseActions.getGroupLocks(this.props.course.id).then((res) => {
            this.setState({ groupLocks: res.results });
          });
          this.props.courseActions.getExclusives(this.props.course.id).then((res) => {
            this.setState({ exclusives: res.results });
          });
          
          // Fetch course rankings
          this.props.courseActions.getCourseRankings(this.props.course.id);
      });

      if (this.props.courses.length == 0) {
        this.props.courseActions.getAllCourses();
      }
      if(this.props.groups.length == 0){
        this.props.groupActions.getAllGroups();
      }
      if(this.props.students.length == 0){
        this.props.studentActions.getAllStudents();
      }
      this.setProgress(this.props.course);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.course.id || nextProps.course != this.props.course) {
      this.setProgress(nextProps.course);
      this.setState({ courseDetails: nextProps.course, classLoaded: true });
    }
  }

  setProgress(course) {
    let progress = ((course.requesting_students * 100) / course.target_capacity).toFixed(0);
    let msg = course.requesting_students > 0 ? course.requesting_students + ' rankings' : 'No rankings yet';
    let progressbar = progress * 0.83333;
    if (progressbar > 100) {
      progressbar = 100;
    }
    this.setState({ progressBar: progressbar });
    this.setState({ progressMsg: msg });
    if (!isNaN(progress)) {
      this.setState({ progress: progress });
    }
  }

  handleClassFormSubmit(values) {
    if (values.id) {
      this.props.courseActions.putCourse(values).then(() => {
        this.props.courseActions.getCourseById(this.props.classId);
        this.props.courseActions.getAllCourses();
      });
    } else {
      this.props.courseActions.createCourse(values).then(res => {
        this.props.courseActions.getCourseById(res.id);
        this.props.courseActions.getAllCourses();
        browserHistory.push('/administer/' + localStorage.getItem('run') + '/class/' + res.id);
      });
    }
  }

  // Meeting Modal
  openAddMeetingModal() {
    this.setState({
      showMeetingModal: true,
      meetingModalValues: {
        title: `${label.createMeeting}`,
        classId: this.props.classId,
        initialValues: {}
      }
    });
  }
  openEditMeetingModal(m) {
    this.setState({
      showMeetingModal: true,
      meetingModalValues: {
        title: `${label.editMeeting}`,
        classId: this.props.classId,
        initialValues: {
          id: m.id,
          day: m.day.toString(),
          location: m.location,
          startdate: m.startdate,
          enddate: m.enddate,
          starttime: m.starttime,
          endtime: m.endtime
        }
      }
    });
  }
  closeMeetingModal() {
    this.setState({ showMeetingModal: false });
  }
  
  // Exclusives Modal
  openExclusivesModal() {
    this.setState({
      showExclusivesModal: true,
      exclusivesModalValues: {
        title: 'CREATE EXCLUSIVE',
        courseId: this.props.course.id,
        groupsArray: this.props.groups,
        coursesArray: this.props.courses,
        initialValues: {

        }
      }
    });
  }
  openEditExclusiveModal(obj) {
    this.setState({
      showExclusivesModal: true,
      exclusivesModalValues: {
        title: 'EDIT EXCLUSIVE',
        courseId: this.props.course.id,
        groupsArray: this.props.groups,
        coursesArray: this.props.courses,
        initialValues: {
          id: obj.id,
          group: obj.groups.map(o => {return o.student_group;}),
          courses: obj.coreqs.map(o => {return o.precond;})
        }
      }
    });
  }
  closeExclusivesModal() {
    this.setState({ showExclusivesModal: false });
  }

  updateExclusives() {
    this.props.courseActions.getExclusives(this.props.course.id).then((res) => {
      this.setState({ exclusives: res.results });
    });
  }

  handleDeleteExclusive() {
    this.props.courseActions.deleteExclusive(this.props.course.id, this.state.exclusiveDeleteId)
      .then(() => {
        this.updateExclusives();
        this.closeDeleteExclusiveModal();
      });
  }

  closeDeleteExclusiveModal() {
    this.setState({ showConfirmExclusiveDelete: false });
  }

  openDeleteExclusiveModal(id) {
    this.setState({
      showConfirmExclusiveDelete: true,
      exclusiveDeleteId: id
    });
  }

  // GroupLocks Modal
  openGroupLocksModal() {
    this.setState({
      showGroupLocksModal: true,
      groupLocksModalValues: {
        title: 'ADD LOCK',
        courseId: this.props.course.id,
        groupsArray: _.filter(this.props.groups, (a)=>{
            return !_.find(this.state.groupLocks, (b)=>{
                return a.id === b.student_group;
            });
        }),
        initialValues: {

        }
      }
    });
  }
  closeGroupLocksModal() {
    this.setState({ showGroupLocksModal: false });
  }

  updateGroupLocks() {
    this.props.courseActions.getGroupLocks(this.props.course.id).then((res) => {
      this.setState({ groupLocks: res.results });
    });
  }

  handleDeleteLock(id) {
    this.props.courseActions.deleteGroupLock(this.props.course.id, id)
      .then(() => {
        this.updateGroupLocks();
      });
  }

  // groupsNotInList(list) {
  //   let arr = [];
  //   for (let i = 0; i < this.props.groups.length; i++) {
  //     _.find(this.state.discountlist, (a)=>{
        
  //     })
  //   }
  // }

  // Discounts Modal
  openDiscountModal() {
    this.setState({
      showDiscountModal: true,
      discountlistModalValues: {
        title: `${label.createDiscount}`,
        courseId: this.props.course.id,
        groupsArray: _.filter(this.props.groups, (a)=>{
            return !_.find(this.state.discountlist, (b)=>{
                return a.id === b.group;
            });
        }),
        initialValues: {

        }
      }
    });
  }
//   _.filter(this.props.groups, (a)=>{
//     return !_.find(this.state.discountlist, (b)=>{
//         return a.id === b.group;
//     });
// })
  openEditDiscountModal(m) {
    this.setState({
      showDiscountModal: true,
      discountlistModalValues: {
        title: `${label.editDiscountlist}`,
        courseId: this.props.course.id,
        groupsArray: this.props.groups,
        initialValues: {
          id: m.id,
          group: m.group,
          amount: parseFloat(m.amount).toString()
        }
      }
    });
  }
  closeDiscountModal() {
    this.setState({ showDiscountModal: false });
  }
  handleDeleteDiscount() {
    if (this.state.discountDeleteId != '') {
      this.props.courseActions.deleteDiscount(this.props.course.id, this.state.discountDeleteId).then(() => {
        this.props.courseActions.getDiscountlist(this.props.course.id).then((res) => {
          this.setState({ discountlist: res.results });
        });
        this.closeDeleteDiscountModal();
      });
    }
  }
  updateDiscountList() {
    this.props.courseActions.getDiscountlist(this.props.course.id).then((res) => {
      this.setState({ discountlist: res.results });
    });
  }

  // Delete Class
  openDeleteCourseModal() {
    this.setState({ showConfirmCourseDelete: true });
  }
  handleDeleteCourse() {
    this.props.courseActions.deleteCourse(this.props.classId).then(() => {
      this.props.courseActions.getAllCourses();
      browserHistory.push('/administer/' + localStorage.getItem('run') + '/classes');
    });
  }
  closeDeleteCourseModal() {
    this.setState({ showConfirmCourseDelete: false });
  }
  // Delete Meeting
  openDeleteMeetingModal(id) {
    this.setState({
      showConfirmMeetingDelete: true,
      meetingDeleteId: id
    });
  }
  handleDeleteMeeting() {
    if (this.state.meetingDeleteId != '') {
      this.props.courseActions.deleteMeeting(this.props.course.id, this.state.meetingDeleteId).then(() => {
        this.props.courseActions.getCourseById(this.props.classId);
        this.closeDeleteMeetingModal();
      });
    }
  }

  closeDeleteMeetingModal() {
    this.setState({ showConfirmMeetingDelete: false });
  }

  formatDate(date) {
    if (date) {
      return Moment(date).format('MM/DD/YYYY');
    } else {
      return '-';
    }
  }
  openDeleteDiscountModal(id) {
    this.setState({
      showConfirmDicountDelete: true,
      discountDeleteId: id
    });
  }

  closeDeleteDiscountModal() {
    this.setState({ showConfirmDicountDelete: false });
  }

  renderAccessRulesSection = () => (
    <div>
      <div className="page-subtitle">Access Rules</div>
        <Row className="mt-4">
          <Col md={12}>
            <span className="subtitle">Locks</span>
            <span className="add-new">
              <i
                onClick={() => {
                  this.openGroupLocksModal();
                }}
                className="fa fa-plus-circle ml-1"
              />
            </span>
          </Col>
        </Row>
        {this.state.groupLocks.length > 0 ? (
          <div className="conflict-row no-span-links">
            <div className="conflict-name">
              <div className="name">
                <span style={conflictnameless}>Groups that cannot take this class:</span>
              </div>
            </div>
            <div className="conflict-courses">
              {this.state.groupLocks.map((c, index) => {
                return (
                  <div key={index} className="conflict-course">
                    <span style={conflictnameless}>
                      {this.props.groups.map((group) => {
                        if (group.id == c.student_group) return group.name
                      })}
                    </span>
                    <span className="ml-1"><i className="fa fa-minus-circle" onClick={()=>{this.handleDeleteLock(c.id)}}></i></span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}

        <Row className="mt-4">
          <Col md={12}>
            <span className="subtitle">EXCLUSIVES</span>
            <span className="add-new">
              <i
                onClick={() => {
                  this.openExclusivesModal();
                }}
                className="fa fa-plus-circle ml-1"
              />
            </span>
          </Col>
        </Row>
        <p>Students can take this class if they satisfy every exclusive (as long as they are not in a locked group).</p>
        {this.state.exclusives.length > 0 ? this.state.exclusives.map((exc) => {
          return (<div className="conflict-row no-span-links">
            <div className="conflict-name">
              <div className="name">
                <span onClick={() => {
                  this.openEditExclusiveModal(exc);
                }}>Students must belong to an exclusive group or satisfy a co-requisite:</span>
              </div>
            </div>
            
            <div className="conflict-courses">
            <div className="executiveclass">
            <span className="tag-title" style={spanStyle}>EXCLUSIVE GROUPS</span>
            {exc.groups.map((c, index) => {
                return (
                  <span key={index} className="conflict-course">
                    <span style={conflictnameless}>
                      {this.props.groups.map((group) => {
                        if (group.id == c.student_group) return group.name
                      })}
                    </span>
                  </span>
                );
              })}
              <div className="icon-delete">
                  <i
                    onClick={() => {
                      this.openDeleteExclusiveModal(exc.id);
                    }}
                    className="fa fa-trash-o"
                    style={{ cursor: 'pointer' }}
                  />
              </div>
            </div>
              
            </div>
            
          
            <div className="conflict-courses">
            <div className="executiveclass">
            <span className="tag-title" style={spanStyle}>CO-REQUISITES</span>
            {exc.coreqs.map((c, index) => {
                return (
                  <span key={index} className="conflict-course">
                    <span style={conflictnameless}>
                    {this.props.courses.map((course) => {
                        if (course.id == c.precond) return course.slug
                      })}
                    </span>
                  </span>
                );
              })}
            </div>
              
            </div>
          </div>)
        }) : null}

        { this.props.courses.length > 0 && (
          <div>
            <AddLocksModal
              closeModal={this.closeGroupLocksModal}
              showModal={this.state.showGroupLocksModal}
              onCancel={this.closeGroupLocksModal}
              initial={this.state.groupLocksModalValues}
              updateGroupLocks={this.updateGroupLocks}
            />
            <AddExclusivesModal
              closeModal={this.closeExclusivesModal}
              showModal={this.state.showExclusivesModal}
              onCancel={this.closeExclusivesModal}
              initial={this.state.exclusivesModalValues}
              updateExclusives={this.updateExclusives}
            />
            <ConfirmDeleteModal
              closeModal={this.closeDeleteExclusiveModal}
              showModal={this.state.showConfirmExclusiveDelete}
              onCancel={this.closeDeleteExclusiveModal}
              customMsg={label.deleteExclusiveCustomMsg}
              confirmButtonTitle="Delete"
              onConfirm={this.handleDeleteExclusive}
            />
          </div>
        )}
        {this.renderStudentRankings()}
    </div>
  );

  // ---- Student Rankings --------------------------------------------------
  renderStudentRankings = () => {
    const { course } = this.props;
    const { sortField, sortDirection } = this.state;
    
    // Count different types of rankings
    let counts = { Favorite: 0, Great: 0, Good: 0, Acceptable: 0 };
    if (course.rankings && course.rankings.length > 0) {
      course.rankings.forEach(r => {
        counts[r.rank]++;
      });
    }
    
    // Get sorted rankings
    const sortedRankings = this.getSortedRankings(course.rankings || []);
    
    // Style for sortable headers
    const sortableHeaderStyle = {
      cursor: 'pointer',
      userSelect: 'none'
    };
    
    // Helper to render sort indicator
    const renderSortIndicator = (field) => {
      if (sortField !== field) return null;
      return sortDirection === 'asc' ? 
        <i className="fa fa-caret-up ml-1"></i> : 
        <i className="fa fa-caret-down ml-1"></i>;
    };
    
    return (
      <div>
        <div className="page-subtitle mt-4">Student Rankings</div>
        
        {course.rankings && course.rankings.length > 0 ? (
          <div>
            <div className="well well-sm mb-3">
              <strong>Student Rankings Summary:</strong> {course.rankings.length} total rankings -
              <span className="label label-primary ml-2 mr-1">{counts.Favorite}</span> Favorite,
              <span className="label label-success ml-2 mr-1">{counts.Great}</span> Great,
              <span className="label label-info ml-2 mr-1">{counts.Good}</span> Good,
              <span className="label label-default ml-2 mr-1">{counts.Acceptable}</span> Acceptable
            </div>
            
            <div className="c-table classes-table mt-2">
              <Table condensed hover striped>
                <thead>
                  <tr>
                    <th 
                      style={sortableHeaderStyle} 
                      onClick={() => this.handleSort('email')}
                      className={sortField === 'email' ? 'text-primary' : ''}
                      title="Click to sort by email"
                    >
                      Student Email {renderSortIndicator('email')}
                    </th>
                    <th 
                      style={sortableHeaderStyle} 
                      onClick={() => this.handleSort('rank')}
                      className={sortField === 'rank' ? 'text-primary' : ''}
                      title="Click to sort by rank category"
                    >
                      Rank {renderSortIndicator('rank')}
                    </th>
                    <th 
                      style={sortableHeaderStyle} 
                      onClick={() => this.handleSort('student_id')}
                      className={sortField === 'student_id' ? 'text-primary' : ''}
                      title="Click to sort by student ID"
                    >
                      Student ID {renderSortIndicator('student_id')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedRankings.map((r, idx) => (
                    <tr key={idx}>
                      <td className="class-desc">
                        {r.student_email ? (
                          <a 
                            href={`/administer/${localStorage.getItem('run')}/student/${r.student_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              const runName = localStorage.getItem('run');
                              browserHistory.push(`/administer/${runName}/student/${r.student_id}`);
                            }}
                          >
                            {r.student_email}
                          </a>
                        ) : (
                          <span className="text-muted">Student ID: {r.student_id}</span>
                        )}
                      </td>
                      <td className="class-desc">
                        {r.rank === 'Favorite' ? (
                          <span className="label label-primary">Favorite</span>
                        ) : r.rank === 'Great' ? (
                          <span className="label label-success">Great</span>
                        ) : r.rank === 'Good' ? (
                          <span className="label label-info">Good</span>
                        ) : (
                          <span className="label label-default">Acceptable</span>
                        )}
                      </td>
                      <td className="class-desc text-muted">{r.student_id}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <div className="alert alert-info">
            <i className="fa fa-info-circle mr-2"></i>
            No student rankings for this course yet
          </div>
        )}
      </div>
    );
  };

  render() {
    const { assignment_complete } = this.props.run;
    if (assignment_complete) return <AddDropClassPage {...this.props}>{this.renderAccessRulesSection()}</AddDropClassPage>;

    return (
      <Col md={12}>
        <div className="page-title">Manage Class</div>
        <AdminSteps active="-1" label={this.props.run.slug} assignment_complete={assignment_complete} />
        {this.props.classId ? (
          <button
            className="btn btn-ter pull-right delete-course"
            onClick={() => {
              this.openDeleteCourseModal();
            }}
          >
            Delete Class
          </button>
        ) : null}
        <Row>
          <Col md={8}>
            {(this.props.classId && this.state.courseDetails.id) || !this.props.classId ? (
              <div>
                {this.props.classId ? (
                  <div className="page-subtitle">
                    <span className="sub-title-gray mr-2">{label.class}</span>
                    {this.props.course.slug}
                  </div>
                ) : (
                  <div className="page-subtitle">Create New Class</div>
                )}

                {this.props.classId && this.props.course.id && this.state.classLoaded ? (
                  <ClassForm onSubmit={this.handleClassFormSubmit} initialValues={this.state.courseDetails} />
                ) : !this.props.classId && !this.state.classLoaded ? (
                  <ClassForm onSubmit={this.handleClassFormSubmit} initialValues={this.state.courseDetails} />
                ) : null}

                {this.props.classId ? (
                  <div>
                    <div className="page-subtitle">Meetings</div>
                    <Row className="mb-2 mt-n-2">
                      <Col md={12}>
                        <button
                          onClick={() => {
                            this.openAddMeetingModal();
                          }}
                          className="btn btn-ter"
                        >
                          {label.addMeeting}
                        </button>
                      </Col>
                    </Row>

                    {this.props.course.meetings.length > 0 ? (
                      <div className="c-table classes-table mt-2">
                        <Table condensed hover>
                          <thead>
                            <tr>
                              <th>Day</th>
                              <th>Location</th>
                              <th>Start Date</th>
                              <th>Start Time</th>
                              <th>End Date</th>
                              <th>End Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.course.meetings.map((meeting, index) => {
                              return (
                                <tr key={index}>
                                  <td className="class-desc">{utils.convertDay(meeting.day)}</td>
                                  <td className="class-desc">{meeting.location}</td>
                                  <td className="class-desc">{this.formatDate(meeting.startdate)}</td>
                                  <td className="class-desc">{meeting.starttime}</td>
                                  <td className="class-desc">{this.formatDate(meeting.enddate)}</td>
                                  <td className="class-desc">{meeting.endtime}</td>
                                  <td className="class-desc">
                                    <i
                                      onClick={() => {
                                        this.openEditMeetingModal(meeting);
                                      }}
                                      className="fa fa-pencil"
                                    />
                                  </td>
                                  <td className="class-desc">
                                    <i
                                      onClick={() => {
                                        this.openDeleteMeetingModal(meeting.id);
                                      }}
                                      className="fa fa-trash"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    ) : null}

                    <div className="page-subtitle">Discounts</div>
                    <Row className="mb-2 mt-n-2">
                      <Col md={12}>
                        <button
                          onClick={() => {
                            this.openDiscountModal();
                          }}
                          className="btn btn-ter"
                        >
                          {label.addDiscount}
                        </button>
                      </Col>
                    </Row>
                    {this.state.discountlist.length > 0 ? (
                      <div className="c-table classes-table mt-2">
                        <Table condensed hover>
                          <thead>
                            <tr>
                              <th>Student Group</th>
                              <th>Discount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.discountlist.map((discount, index) => {
                              return (
                                <tr key={index}>
                                  <td className="class-desc">{this.props.groups.map((group) => {
                                    if (group.id == discount.group) return group.name
                                  })}</td>
                                  <td className="class-desc">{parseFloat(discount.amount) + '%'}</td>
                                  <td className="class-desc">
                                    <i
                                      onClick={() => {
                                        this.openEditDiscountModal(discount);
                                      }}
                                      className="fa fa-pencil"
                                    />
                                  </td>
                                  <td className="class-desc">
                                    <i
                                      onClick={() => {
                                        this.openDeleteDiscountModal(discount.id);
                                      }}
                                      className="fa fa-trash"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    ) : null}
                    {this.renderAccessRulesSection()}
                    {this.props.courses.length > 0 ? (
                      <div>
                        <AddMeetingModal
                          closeModal={this.closeMeetingModal}
                          showModal={this.state.showMeetingModal}
                          onCancel={this.closeMeetingModal}
                          initial={this.state.meetingModalValues}
                        />
                        <AddDiscountModal
                          closeModal={this.closeDiscountModal}
                          showModal={this.state.showDiscountModal}
                          onCancel={this.closeDiscountModal}
                          initial={this.state.discountlistModalValues}
                          updateDiscountList={this.updateDiscountList}
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : (
              <Spinner spinnerName="three-bounce" />
            )}
          </Col>
          <Col md={4}>
            {this.props.classId && this.state.classLoaded ? (
              <div className="sidebar-container">
                <div className="sidebar-header">{label.progressSidebarTitle}</div>
                <div className="progress-box mt-4">
                  {this.state.progressMsg}
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: this.state.progressBar + '%' }}
                    />
                  </div>
                  <div
                    className="relative class-progress-bar"
                    style={{
                      width: 83.33 + '%',
                      backgroundColor: 'rgba(80,80,80,0.2)',
                      height: '20px',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      top: '-25px'
                    }}
                  >
                    <i className="fa fa-caret-up progress-bar-arrow" />
                    <span className="progress-bar-arrow-percentage">100%</span>
                  </div>
                  <p>{this.state.progress + '% of target capacity'}</p>
                </div>
              </div>
            ) : null}
          </Col>
        </Row>
        <ConfirmDeleteModal
          closeModal={this.closeDeleteMeetingModal}
          showModal={this.state.showConfirmMeetingDelete}
          onCancel={this.closeDeleteMeetingModal}
          customMsg={label.deleteMeetingCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteMeeting}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteCourseModal}
          showModal={this.state.showConfirmCourseDelete}
          onCancel={this.closeDeleteCourseModal}
          customMsg={label.deleteCourseCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteCourse}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteDiscountModal}
          showModal={this.state.showConfirmDicountDelete}
          onCancel={this.closeDeleteDiscountModal}
          customMsg={label.deleteDiscountCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteDiscount}
        />
      </Col>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let classId = null;
  if (ownProps.params.id) {
    classId = ownProps.params.id;
  }
  return {
    run: state.run,
    courses: state.courses,
    course: state.course,
    classId: classId,
    discountlist: state.discountlist,
    groupLocks: state.groupLocks,
    exclusives: state.exclusives,
    groups: state.groups,
    students: state.students
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch),
    groupActions: bindActionCreators(groupActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassPageContainer);



// WEBPACK FOOTER //
// ./src/components/classes/ClassPageContainer.js